import "./bootstrap";

window.resetForm = function (targetForm) {
    $(targetForm)[0].reset();
    $(targetForm).eq(0).find("select").val("").trigger("change");
    $(targetForm).validate().resetForm();
};

window.toggleFilter = function (targetId) {
    if ($(targetId).hasClass("d-none")) {
        if ($(window).width() >= 992) {
            $(targetId).addClass(
                "animate__animated animate__faster animate__fadeIn",
            );

            $(targetId).removeClass("animate__slideInUp");
        } else {
            $(targetId).addClass(
                "animate__animated animate__faster animate__slideInUp",
            );

            $(targetId).removeClass("animate__fadeIn");
        }

        $(targetId).removeClass("d-none");

        $("body").css("overflow-y", "hidden");
    } else {
        $(targetId).addClass("d-none");

        $("body").css("overflow-y", "auto");
    }
};

$(document).ready(function () {
    $(".filter-popup-wraper").click(function (event) {
        if (!$(event.target).closest(".filter-popup-content").length) {
            toggleFilter(this);
        }
    });

    $(".modal.draggable>.modal-dialog").draggable({
        cursor: "move",
        handle: ".modal-header",
    });
    $(".modal.draggable>.modal-dialog>.modal-content>.modal-header").css(
        "cursor",
        "move",
    );

    $(document).on("submit", "form", function () {
        if ($(this).attr("target") === "_blank") {
            return;
        }

        let btn = $(this).find('[type="submit"]');

        if (!btn.length) {
            btn = $(this).find(".submit-btn").first();
        }

        btn.prop("disabled", true);
        btn.data("original-text", btn.html());
        btn.html(
            `Loading <i class="fa-solid fa-circle-notch loading-icon"></i>`,
        );
    });

    $(document).ajaxComplete(function () {
        $("form").each(function () {
            let btn = $(this).find('[type="submit"]');

            if (!btn.length) {
                btn = $(this).find(".submit-btn").first();
            }

            if (btn.data("original-text")) {
                btn.prop("disabled", false);
                btn.html(btn.data("original-text"));
            }
        });
    });
});
